"use strict";import{SideNavHeading as e}from"./src/SidenavHeading.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-sidenav-heading",e);
//# sourceMappingURL=sp-sidenav-heading.js.map
